import { render, staticRenderFns } from "./HomeCaseDetails.vue?vue&type=template&id=5b3a9d35&scoped=true&"
import script from "./HomeCaseDetails.vue?vue&type=script&lang=js&"
export * from "./HomeCaseDetails.vue?vue&type=script&lang=js&"
import style0 from "./HomeCaseDetails.vue?vue&type=style&index=0&id=5b3a9d35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3a9d35",
  null
  
)

export default component.exports